/**
 * Skip link for keyboard users to jump past the sticky nav into main content.
 */

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './SkipLink.css';

const SkipLink = () => {
  const { t } = useLanguage();

  return (
    <a href="#main-content" className="skip-link">
      {t('a11y.skipToContent')}
    </a>
  );
};

export default SkipLink;
